import React, { useEffect, useRef, useState } from "react";
import control_button_icon from 'src/assets/icons/control-button.svg';

interface IInputWithShortcutsProps {
  placeholder: string;
  onSearch: (value: string) => void;
  className?: string;
  extraShortKey?: string;
}

const InputWithShortcuts: React.FC<IInputWithShortcutsProps> = ({
  placeholder,
  onSearch,
  className = "",
  extraShortKey = "K",
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [value, setValue] = useState("");

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      onSearch(value);
    }, 300);

    return () => {
      clearTimeout(debounceTimeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key.toLowerCase() === extraShortKey.toLowerCase()) {
        event.preventDefault();
        inputRef.current?.focus();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`relative ${className}`}>
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="pl-3 pr-24 py-2 text-gray-700 border border-gray-300 rounded-md w-full focus:outline-none focus:border-blue-500"
        placeholder={placeholder}
        ref={inputRef}
      />
      <div className="absolute inset-y-0 right-0 flex items-center pr-1 space-x-1">
        <div className="bg-transparent-500 text-gray-400 px-3 py-1 rounded-lg text-sm border border-gray-200">
          <img src={control_button_icon} alt='' />
        </div>
        <div className="bg-transparent-500 text-gray-400 px-3 py-1 rounded-lg text-sm border border-gray-200">
          {extraShortKey}
        </div>
      </div>
    </div>
  );
};

export default InputWithShortcuts;
